import Tooltip from '@mui/material/Tooltip'

import * as S from './TooltipContainer.styles'

interface TooltipContainerProps {
  clearTooltip: () => void
  title?: string
  bounds?: {
    x: number
    y: number
    width: number
    height: number
  }
}

export const TooltipContainer = ({ title, bounds, clearTooltip }: TooltipContainerProps) => {
  if (!bounds || !title) {
    return null
  }

  const { x, y, width, height } = bounds

  return (
    <>
      {/* This box fills all space based on bounds, catching onMouseLeave to clear the tooltip */}
      <S.HoverArea
        onMouseLeave={clearTooltip}
        x={x}
        y={y}
        width={width}
        height={height}
        zIndex={3}
      />
      {/* This box positions the tooltip in the middle of the bounds */}
      <S.TooltipAnchor x={x + width / 2} y={y} width={1} height={1} zIndex={2}>
        <Tooltip open={true} title={title} placement="top" arrow>
          <span />
        </Tooltip>
      </S.TooltipAnchor>
    </>
  )
}
